import { cellSizeMin } from 'assets/js/editor/table/table';
import DesignFacade from '../../../../facade/design/design';

import tableCreationtemplate from './templates/table.hbs';

/**
 * Renders a collection of boxes to quickly set table dimensions
 * and create a table based on that
 */
class SimpleTableMenuItems {
  /**
   * @param {HTMLElement} container
   */
  constructor (container) {
    // Deafult settings
    this.tableSize = { rows: 3, columns: 3 };

    this.container = container;
    this.container.parentElement.addEventListener('click', this.render.bind(this));
    this.editor = INKIVE.Tool.getInstance().editor;
  }

  render () {
    // Create an array of 5x5 boxes that can be highlighted
    // If table edit mode is set, just render a button to quit this mode
    this.container.innerHTML = tableCreationtemplate({ editMode: false, cells: Array.from({ length: 5 }) });

    // User can highlight a cell to use its coordinates to specify the new table dimensions
    const allCells = this.container.querySelectorAll('.table-creation-template-cell');
    allCells.forEach(cell => {
      // Set the new table dimensions on mouse hover
      cell.addEventListener('mouseover', this.setTableSizeFromHighlightedCell.bind(this));
      // Create a table on click
      cell.addEventListener('click', this.createTable.bind(this));
    });
    this.container.querySelector('span').innerText = `0x0 ${INKIVE.TranslateHelper.data.popupmenu.dropdown_title.root_table}`;
  }

  /**
   * @param {MouseEvent} event
   */
  setTableSizeFromHighlightedCell (event) {
    if (!event.target) return;

    this.tableSize.rows = parseInt(event.target.getAttribute('data-row')) + 1;
    this.tableSize.columns = parseInt(event.target.getAttribute('data-column')) + 1;

    const allCells = this.container.querySelectorAll('.table-creation-template-cell');

    // A css class to highlight a cell
    const highlightClassName = 'table-creation-template-cell-highlighted';

    allCells.forEach(cell => {
      const row = parseInt(cell.getAttribute('data-row'));
      const column = parseInt(cell.getAttribute('data-column'));

      const isHighlighted = cell.classList.contains(highlightClassName);

      if (row < this.tableSize.rows && column < this.tableSize.columns) {
        // If the cell offers a bigger table
        isHighlighted || cell.classList.add(highlightClassName);
      } else {
        isHighlighted && cell.classList.remove(highlightClassName);
      }
    });

    this.container.querySelector('span').innerText = `${this.tableSize.rows}x${this.tableSize.columns} ${INKIVE.TranslateHelper.data.popupmenu.dropdown_title.root_table}`;
  }

  /**
   * @param {MouseEvent} event
   */
  createTable (event) {
    // Get table dimensions from clicked cell coordinates
    this.tableSize.rows = parseInt(event.target.getAttribute('data-row')) + 1;
    this.tableSize.columns = parseInt(event.target.getAttribute('data-column')) + 1;

    // Used to position the new table
    const offset = this.editor.getOffset();

    const width = Math.max(this.editor.canvas.contentW * 3 / 5, cellSizeMin.width * this.tableSize.columns);
    const height = Math.max(this.editor.canvas.contentH * 3 / 5, cellSizeMin.height * this.tableSize.rows);

    const cellWidth = Math.max(width / this.tableSize.columns, cellSizeMin.width);
    const cellHeight = Math.max(height / this.tableSize.rows, cellSizeMin.height);

    DesignFacade.create('table', {
      x: Math.floor4(offset.width - width) / 2,
      y: Math.floor4(offset.height - height) / 2,
      width,
      height,
      rowsCount: this.tableSize.rows,
      columnsCount: this.tableSize.columns,
      cellWidth,
      cellHeight
    });

    // Trigger a blur event so tooltip fades away
    const dropdownTitleElement = this.container.parentElement.querySelector('span.ui-dropdown-title');
    dropdownTitleElement.dispatchEvent(new Event('blur'));
  }
}

export default SimpleTableMenuItems;
